/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './tnc.module.scss';
import { getOperatorTnc } from '~helpers/getters';

const Tnc = ({ operator, isFixed = false }) => {
  const termsConditions = getOperatorTnc(operator);
  return (
    termsConditions &&
    ((!isFixed && (
      <div
        className={`${styles.container} ${styles.tnc || ''}`}
        dangerouslySetInnerHTML={{ __html: termsConditions }}
      />
    )) || (
      <div className={`${styles.container} ${styles.tnc || ''} ${isFixed ? styles.isFixed : ''}`}>
        <div
          tabIndex={`${isFixed ? 0 : -1}`}
          className={`${styles.innerTnc || ''}`}
          dangerouslySetInnerHTML={{ __html: termsConditions }}
        />
      </div>
    ))
  );
};

Tnc.propTypes = {
  isFixed: PropTypes.bool,
  operator: PropTypes.shape({
    short_name: PropTypes.string,
    type: PropTypes.string,
    links: PropTypes.shape({
      tnc: PropTypes.string,
      main: PropTypes.string,
    }),
  }),
};

export default Tnc;
